import {
  IGetComparisonDesktopResponse,
  IGetComparisonDesktopResponse200,
} from '../../repositories/offers-comparison/v2/get-comparison-desktop';

export const mapComparisonResponse = (response: IGetComparisonDesktopResponse): IGetComparisonDesktopResponse200 => {
  return {
    statusCode: 200,
    headers: [],
    response,
  };
};
